<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import WpsHandleMixin from '@/mixins/network/wpsHandle'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'App',
  mixins: [WpsHandleMixin],
  created () {
    this.setOperationId()
  },
  computed: {
    ...mapGetters(['isPc', 'loginObject', 'fileObject'])
  },
  methods: {
    ...mapMutations(['set_operation_Id']),
    setOperationId(){
      const time = new Date().getTime()
      this.set_operation_Id(`${this.fileObject.docId || 0}-${this.loginObject.userId || 0}-${this.isPc ? 1 : 0}-${time}`)
    }
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue